/**
 * Scroll Animation.
 * */

require('intersection-observer');

 export default {
  init() {

    $('.featured-content__image').each(function() {
      if($(this).parent().hasClass('aligned-right')) {
        $(this).addClass('fade-right');
      } else {
        $(this).addClass('fade-left');
      }
    });

    $('.featured-content__text').addClass('fade-up');
    $('.our-capabilities .container').addClass('fade-up');
    $('.major-clients .container').addClass('fade-up');
    $('.call-to-action .container').addClass('fade-up');
    $('.our-products__container').addClass('fade-up');
    $('.product-range__main-title').addClass('fade-up');
    $('.product-range__cards').addClass('fade-up');
    $('.card').addClass('fade-up');
    $('.animate-up').addClass('fade-up');
    $('.custom-card').addClass('fade-up');
    $('.card-video').addClass('fade-up');
    $('.form').addClass('fade-up');
    $('.tabs').addClass('fade-up');
    $('.business-family__container').addClass('fade-up');
    $('.what-we-do__container').addClass('fade-up');
    $('.tabs__image').addClass('fade-right');
    $('.tabs__text').addClass('fade-up');


    // Get all of the images that are marked up to animate load
    const animateEl = document.querySelectorAll('.fade-up, .fade-right, .fade-left');
    const config = {
      // If the image gets within 50px in the Y axis, start the download.
      rootMargin: '50px 0px',
      threshold: 0.01,
    };

  // The observer for the animateEl on the page
    let observer = new IntersectionObserver(onIntersection, config);
    for(var i=0; i < animateEl.length; i++) {
      observer.observe(animateEl[i]);
    }

    function onIntersection(entries) {
      // Loop through the entries
      for(var i=0; i < entries.length; i++) {
        // Are we in viewport?
        if (entries[i].intersectionRatio > 0) {
          $(entries[i].target).addClass('animate');
        } else {
          $(entries[i].target).removeClass('animate');
        }
      }
    }

  },
}



// WEBPACK FOOTER //
// ./scripts/lib/animation.js